<template>
  <section>
    <section class="hero is-info">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Hero title
          </h1>
          <h2 class="subtitle">
            Hero subtitle
          </h2>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
  export default {
    name: 'home'
  }
</script>



// WEBPACK FOOTER //
// Home.vue?13e2e1c4